var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 2.9053C8.10005 2.9053 2.50005 8.50529 2.50005 15.4053C2.50005 22.3053 8.10005 27.9053 15.0001 27.9053C21.9001 27.9053 27.5001 22.3053 27.5001 15.4053C27.5001 8.50529 21.9001 2.9053 15.0001 2.9053ZM12.5001 21.6553L6.50005 16L8.26255 14.2375L12.5001 18.1178L21.0001 10.5L22.7626 12.275L12.5001 21.6553Z",
    fill: "#024363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 2.9053C8.10005 2.9053 2.50005 8.50529 2.50005 15.4053C2.50005 22.3053 8.10005 27.9053 15.0001 27.9053C21.9001 27.9053 27.5001 22.3053 27.5001 15.4053C27.5001 8.50529 21.9001 2.9053 15.0001 2.9053ZM12.5001 21.6553L6.50005 16L8.26255 14.2375L12.5001 18.1178L21.0001 10.5L22.7626 12.275L12.5001 21.6553Z",
    fill: "#024363"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 21.6553L6.50005 16L8.26255 14.2375L12.5001 18.1178L21.0001 10.5L22.7626 12.275L12.5001 21.6553Z",
    fill: "#024363"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.6553L6.5 16L8.2625 14.2375L12.5 18.1178L21 10.5L22.7625 12.275L12.5 21.6553Z",
    fill: "#A5D8D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.6553L6.5 16L8.2625 14.2375L12.5 18.1178L21 10.5L22.7625 12.275L12.5 21.6553Z",
    fill: "#A5D8D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.6553L6.5 16L8.2625 14.2375L12.5 18.1178L21 10.5L22.7625 12.275L12.5 21.6553Z",
    fill: "#A5D8D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.b48a8bdb.svg";
export { ForwardRef as ReactComponent };